import React from 'react';
import { Box, Divider } from '@mui/material';
import {
  APP_SHELL_HEADER_BORDER,
  appShellHeaderSx,
} from './layoutConstants';

interface PageHeaderBarProps {
  children: React.ReactNode;
  showDivider?: boolean;
}

export const PageHeaderBar: React.FC<PageHeaderBarProps> = ({
  children,
  showDivider = false,
}) => (
  <>
    <Box sx={appShellHeaderSx}>{children}</Box>
    {showDivider && (
      <Divider sx={{ borderColor: APP_SHELL_HEADER_BORDER, flexShrink: 0 }} />
    )}
  </>
);
